module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_withpet@3x-72c4b9cf6df2ebef8d6f327deb164dc0.webp";